import script from "./SiSaSgCard.vue?vue&type=script&setup=true&lang=js"
export * from "./SiSaSgCard.vue?vue&type=script&setup=true&lang=js"

import "./SiSaSgCard.vue?vue&type=style&index=0&id=1c9e4e24&lang=less"

const __exports__ = script;

export default __exports__